import { isTeacherMockContext } from '@/utils/homeworkSession';
import i18n from '@/locales/init'; 
import style from './index.module.less';

export default function Analysis(props: any) {
  if (isTeacherMockContext()) return null;
  return <span {...props} className={style.analysis} data-disable={true}>{i18n.t('common.dauyan_question_analysis')}</span>;
}
